// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wecW","col":"styles_col__1pXBF","actions":"styles_actions__7uX4p","conflict":"styles_conflict__1qDWg"};